import CarouselLinks from 'shared/assets/scripts/carouselLinks'

export default class TabsLink {
	private tabsLink: HTMLElement | null
	private isDesktop: boolean

	constructor() {
		this.tabsLink = document.querySelector('.tabsLink')
		this.isDesktop = window.matchMedia('(min-width: 1000px)').matches
	}

	init() {
		if (this.isDesktop && this.tabsLink) {
			const carouselLinks = new CarouselLinks(this.tabsLink)
			carouselLinks.init()
		}
	}
}
